<template>
  <cms-section v-if="content.components" :section="{ name: 'dialog-content', items: content.components }" />
</template>

<script setup lang="ts">
import type { DialogGenericContent } from '#types/components/cms/dialog'

const { content } = defineProps<{
  content: DialogGenericContent
}>()
</script>
